// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3exPu","type":"styles_type__1Dgs8","choices":"styles_choices__39PVV"};